import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
   * **Hotres**
   *
   * @exports bs_446
   * @category engines
   */
const factory = function factory({ window, document, thn }) {
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.roomsWrap .room'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('.title')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.rate')).filter((rate) => thn.isVisible(rate))
                ?.map((rate) => {
                const rateName = rate.querySelector('.title')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.price')?.textContent);
                const hasBreakfast = !!rate.querySelector('.icon-coffee');
                const isRefundable = true;
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        generateSearchUrl(ctx) {
            // https://panel.hotres.pl/v4_step1?oid=1622&lang=en&ref=grzechowiakgorskieapartamenty.pl&clear=1&arrival=2024-04-18&departure=2024-04-20
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.match(/hotres/);
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            // Export into ctx.newUrl
            ctx.newUrl = url.toString();
            return ctx;
        },
        isUserLogged() {
            const isLogged = false;
            return isLogged;
        },
        onStateChange() {
            setTimeout(thn.pageCheck, 800);
        },
        priceObserveDom(ctx) {
            const resultContainer = document.querySelector('#searchResult');
            if (resultContainer) {
                const refreshPrice = thn.debounce(() => {
                    const isLoading = thn.isVisible(document.querySelector('.preloader'));
                    if (!isLoading) {
                        ctx.widget.refresh();
                    }
                }, 600);
                thn.observeDom(resultContainer, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    refreshPrice.cancel();
                    thn.stopObserveDom(resultContainer, refreshPrice);
                });
            }
        },
        priceParseData() {
            let adults = 2;
            let children = 0;
            let infants = 0;
            let childrenNotInfants = 0;
            const rooms = document.querySelectorAll('.chooserRoomWrap .chooserRoomList .room');
            // Guests, Adults & Children
            let guestsObj = {};
            const currentRoom = thn.parseNumber(document.querySelector('.chooseRoomsTitle')?.textContent?.split('/')[0]) || 1;
            const guestsData = rooms[currentRoom - 1];
            if (!thn.empty(guestsData)) {
                const adultsInputElement = guestsData.querySelector('.adults');
                const childrenInputElement = guestsData.querySelectorAll('.childs');
                const childrenArray = Array.from(childrenInputElement);
                guestsObj = {
                    adults: (adultsInputElement && thn.parseNumber(adultsInputElement?.value)) || adults,
                    children: (!thn.empty(childrenArray) && thn.parseNumber(childrenArray[1]?.value)) || children,
                    infants: (!thn.empty(childrenArray) && thn.parseNumber(childrenArray[0]?.value)) || infants,
                };
            }
            if (!thn.empty(guestsObj)) {
                adults = guestsObj.adults;
                childrenNotInfants = guestsObj.children;
                infants = guestsObj.infants;
                children = childrenNotInfants + infants;
            }
            const childrenAges = Array(childrenNotInfants).fill(11).concat(Array(infants).fill(1));
            // Dates
            const dateBegin = (thn.parseUrlParameter('arrival') || document.querySelector('#arrival')?.value)?.replace(/-/g, '/');
            const dateEnd = (thn.parseUrlParameter('departure') || document.querySelector('#departure')?.value)?.replace(/-/g, '/');
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd);
            // Prices & Currency || No Rooms
            const prices = Array.from(document.querySelectorAll('.roomsWrap .room .price'))
                .map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => value !== null && value !== undefined && value !== 0);
            const currency = thn.parseCurrency(document.querySelector('.price')?.textContent);
            const noAvailability = !thn.isVisible(document.querySelector('#searchResult .room')) || document.querySelector('.changeOfferExplanationMsg');
            if (noAvailability) {
                return {
                    adults,
                    children,
                    currency,
                    roomsDispo: [{ adults, children, childrenAges: childrenAges || [] }],
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            if (!thn.empty(prices) && currency && nights) {
                return {
                    adults,
                    children,
                    dateBegin,
                    dateEnd,
                    price: Math.min(...prices) / nights,
                    currency,
                    roomsDispo: [{ adults, children, childrenAges: childrenAges || [] }],
                    roomDetails: roomDetailsParseData(adults, children),
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingId = document.querySelector('.topImgTitle h1, .title')?.innerText?.split(' ').pop();
            const dataLayerPurchase = thn.objectGet(window.dataLayer, 'ecommerce', { first: false }) ?? {};
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const datesText = Array.from(document.querySelectorAll('.stayDates .date'));
            const dateBeginText = datesText?.[0]?.textContent?.trim() || '';
            const dateEndText = datesText?.[1]?.textContent?.trim() || '';
            const dateBegin = translateDate(dateBeginText, thn.data.language);
            const dateEnd = translateDate(dateEndText, thn.data.language);
            const purchaseItems = dataLayerPurchase.items ?? [];
            const priceText = document.querySelector('.summary .amount')?.textContent || purchaseItems[0]?.value?.toString() || '';
            const price = thn.parseNumber(priceText);
            const currency = thn.parseCurrency(priceText);
            const rooms = purchaseItems?.length || 1;
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
                rooms,
            };
        },
    };
};

export { factory };
